import React, { useState } from 'react';
import { Navbar, Nav, NavDropdown, Container } from 'react-bootstrap';

import { Link } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import "./Navbar.css"
import { impactStoryThemes } from '../data/impact-stories';

const CustomNavbar = ({ darkMode, toggleTheme, projects }) => {
    const [expanded, setExpanded] = useState(false);

    const closeNav = () => setExpanded(false);

    return (
        <Navbar
            expanded={expanded}
            onToggle={(val) => setExpanded(val)}
            style={{
                backgroundColor: darkMode ? '#1B5E20' : '#A5D6A7',
                transition: 'background-color 0.3s ease',
                position: "sticky"
            }}
            variant={darkMode ? 'dark' : 'light'}
            expand="lg"
            fixed="top"
        >
            <Container>
                <Navbar.Brand as={Link} to="/" onClick={closeNav} className="d-flex align-items-center" style={{ textDecoration: 'none' }}>
                    <img
                        alt="PSGS Logo"
                        src="/logo-pruthvi-sangram.jpg"
                        style={{
                            width: '44px',
                            height: '44px',
                            borderRadius: '6px',
                            mixBlendMode: 'multiply',
                            marginRight: '10px'
                        }}
                    />
                    <span className="org-name" style={{
                        fontSize: '1.15rem',
                        fontWeight: '600',
                        color: darkMode ? '#fff' : '#1B5E20',
                        letterSpacing: '0.3px'
                    }}>
                        Pruthvisangram Gramvikas Sanstha
                    </span>
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav"/>
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="justify-content-end" style={{ width: "100%" }}>
                        <NavDropdown title="Our Impact" id="impact-nav-dropdown">
                            <NavDropdown.Item as={Link} to="/our-impact" onClick={closeNav}>
                                All Impact Stories
                            </NavDropdown.Item>
                            <NavDropdown.Divider />
                            {impactStoryThemes.map((theme) => (
                                <NavDropdown.Item
                                    key={theme.id}
                                    as={Link}
                                    to={"/our-impact/" + theme.id}
                                    onClick={closeNav}
                                >
                                    {theme.label}
                                </NavDropdown.Item>
                            ))}
                        </NavDropdown>
                        <Nav.Link as={Link} to="/about" onClick={closeNav}>Our Journey</Nav.Link>
                        {/* <NavDropdown title="Our Programs" id="programs-nav-dropdown">
                            {projects.map((project) => (
                                <NavDropdown.Item
                                    key={project.id}
                                    as={Link}
                                    to={"/programs/" + project.value}
                                    onClick={closeNav}
                                >
                                    {project.label}
                                </NavDropdown.Item>
                            ))}
                        </NavDropdown> */}
                        <Nav.Link as={Link} to="/training-center" onClick={closeNav}>Training Center</Nav.Link>
                        <Nav.Link as={Link} to="/where-we-work" onClick={closeNav}>Where We Work</Nav.Link>
                        <Nav.Link as={Link} to="/how-to-help" onClick={closeNav}>How to Help</Nav.Link>
                        <Nav.Link as={Link} to="/csr-success-stories" onClick={closeNav}>CSR Success Stories</Nav.Link>
                        <Nav.Link as={Link} to="/contact" onClick={closeNav}>Contact Us</Nav.Link>
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
};

export default CustomNavbar;
